/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { SAMPLE_TO_SALE_SCREEN, COMMON } from '../../global/Constants';
import './sample-to-sale.css';
import ViewImage from '../common/ViewImage';
import Utilities from '../../global/Utilities';
import DataProvider from '../../providers/DataProvider';

class HarvestVegView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            harvests: [],
            harvest: {},

            // harvestDetails: {
            //     hybrid1: {
            //         name: "US 50",
            //         totalPickCount: "04",
            //         data: [
            //             { harvesting_Date: "30/1/2020", hybrid: "250" },
            //             { harvesting_Date: "30/1/2020", hybrid: "150" },

            //         ]
            //     },
            //     hybrid2: {
            //         name: "CH101",
            //         totalPickCount: "03",
            //         data: [
            //             { check_harvesting_Date: "27/1/2020", check_variety_hybrid: "250" },
            //             { check_harvesting_Date: "27/1/2020", check_variety_hybrid: "150" },
            //         ]
            //     },
            //     remarks: "Remarks go here",
            //     images: ["../assets/images/krishak-info-img1.png", "../assets/images/krishak-info-img2.png"]
            // }

        }
    }

    componentDidMount() {
        const { harvestDetailStage } = this.props;
        if (harvestDetailStage !== undefined && harvestDetailStage !== null) {
            if (harvestDetailStage.length > 0) {
                let harvestArray = [];
                for (let i = 0; i < harvestDetailStage.length; i++) {
                    let harvestObj = harvestDetailStage[i];
                    let harvest = {
                        harvest_id: harvestObj.harvest_id,
                        name: "Harvest " + (i + 1),
                        data: harvestObj
                    }
                    harvestArray.push(harvest);
                }
                this.setState({ harvests: harvestArray, harvest: harvestArray[0]?.data });
            }
        }
    }

    handleChange = ({ target }) => {
        Utilities.LogPrint("Selected Harvest", target.value);
        const { harvests } = this.state;
        const harvestObj = harvests.find(item => item.harvest_id === parseInt(target.value));
        Utilities.LogPrint(harvestObj);
        this.setState({ harvest: harvestObj?.data });
    }

    getCompetitorHybrid = () => {
        const { harvestDetailStage } = this.props;
        const competitorHybrids = DataProvider.getInstance().getCompetitorHybrids();
        if (competitorHybrids) {
            Utilities.LogPrint(`competitorHybrid:`, harvestDetailStage[0]?.competitor_hybrid_id);
            Utilities.LogPrint(`competitorHybrid 1:`, competitorHybrids);
            const competitorHybridId = harvestDetailStage[0]?.competitor_hybrid_id;
            const competitorHybrid = competitorHybrids.find(item => item.competitor_hybrid_id === competitorHybridId);
            if (competitorHybrid) {
                Utilities.LogPrint(`competitorHybrid:`, competitorHybrid);
                return competitorHybrid?.season_name;
            } else {
                return "";
            }
        }
        return "";
    }

    getImages() {
        const { harvestDetailStage } = this.props;
        let images = [];
        if (harvestDetailStage != null || harvestDetailStage?.length > 0) {
            for (let i = 0; i < harvestDetailStage.length; i++) {
                const harvest = harvestDetailStage[i];
                for (let j = 0; j < harvest?.images?.length; j++) {
                    const objImage = harvest?.images[j];
                    images.push(objImage);
                }
            }
        }
        Utilities.LogPrint("IMAGES", images);
        return images;
    }



    render() {
        const { harvests, harvest } = this.state;
        const { harvestDetailStage, hybridName } = this.props;
        Utilities.LogPrint("HarvestDetailStage====>", harvestDetailStage);

        return (
            <div>
                {/* Mobile View */}
                <div className="row d-md-none">
                    <div className="col-12 px-sm-3">

                        {harvests?.length > 1 ?
                            <div className="form-group">
                                <select className="form-control max-w-360"
                                    onChange={this.handleChange}>
                                    {
                                        harvests.map((item, i) =>
                                            <option key={i} value={item.harvest_id} >{item.name}</option>)
                                    }
                                </select>
                            </div> : null
                        }

                        {/* <div className="form-group">
                            <select className="form-control max-w-360"
                                onChange={this.handleChange}>
                                {
                                    harvests.map((item, i) =>
                                        <option key={i} value={item.harvest_id} >{item.name}</option>)
                                }
                            </select>
                        </div> */}


                        <div className="mb-4">

                            <div className="row mb-2">
                                <div className="col-4">Harvesting Date</div>
                                <div className="col-8">
                                    <span className="d-block font-weight-medium">{Utilities.formatDate(harvest?.harvest_date)}</span>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-4">US Hybrid (tons/ac)</div>
                                <div className="col-8">
                                    <span className="d-block font-weight-medium">{harvest?.harvest_yield_kg_plot}</span>
                                </div>
                            </div>

                        </div>

                        <div className="row mb-2">
                            <div className="col-4">{SAMPLE_TO_SALE_SCREEN.VARIETY_HYBRID}</div>
                            <div className="col-8">
                                <span className="d-block font-weight-medium">{SAMPLE_TO_SALE_SCREEN.HYBRID_NAME}</span>
                            </div>
                        </div>

                        <div className="mb-4">
                            <div className="row mb-2">
                                <div className="col-4">Harvesting Date</div>
                                <div className="col-8">
                                    <span className="d-block font-weight-medium">{Utilities.formatDate(harvest?.check_variety_harvest_date)}</span>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-4">Check Hybrid (tons/ac)</div>
                                <div className="col-8">
                                    <span className="d-block font-weight-medium">{harvest?.check_variety_harvest_yield_kg_plot}</span>
                                </div>
                            </div>

                        </div>

                        {/* Remark & Image */}
                        <div className="row">
                            <div className="col-md-6 col-12">
                                <span className="d-flex w-100 align-items-center mt-2 mt-md-3">
                                    {COMMON.REMARKS}
                                </span>
                                <span className="d-flex font-weight-medium mb-2">{harvest?.remark}</span>

                                <div className="row m-md-0 d-md-none">
                                    <hr className="w-100" />
                                </div>
                            </div>

                            {/* Images Info */}
                            {
                                harvest?.images ?
                                    <div className="col-md-6 col-12">
                                        <span className="font-weight-medium d-flex w-100 align-items-center mt-1 mb-2">{COMMON.IMAGES}</span>
                                        <div className="row row7-5 mb-3">
                                            {
                                                harvest?.images.length ?
                                                    harvest?.images.map((image, i) => (
                                                        <ViewImage key={i} image={image.image_url} />
                                                    )) : null
                                            }
                                        </div>
                                    </div> : null
                            }
                        </div>

                    </div>
                </div>

                {/* Desktop View */}
                <div className="row d-none d-md-flex harvest-details-wrapper pb-65">
                    <div className="col-6">
                        <h6 className="fs-18">SW Hybrid : {hybridName}</h6>
                    </div>
                    <div className="col-6 text-right">
                        <span>Total Picking Count :  0{harvestDetailStage?.length}</span>
                    </div>
                    <div className="col-12">
                        <div className="harvest-details-table-scroll mb-5">
                            <table className="table attendedby-table harvest-details-table mb-0">
                                <thead>
                                    <tr>
                                        <th>Harvesting Date</th>
                                        <th>US Hybrid (tons/ac) </th>
                                        {/* <th>Remark</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        harvestDetailStage?.length ?
                                            harvestDetailStage.map((item, i) => (
                                                <tr key={i}>
                                                    <td>{Utilities.formatDate(item?.harvest_date)}</td>
                                                    <td>{item.harvest_yield_kg_plot}</td>
                                                    {/* <td>{item.remark}</td> */}
                                                </tr>
                                            )) : null
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="col-6">
                        <h6 className="fs-18">Check Harvest Hybrid : {this.getCompetitorHybrid()}</h6>
                    </div>
                    <div className="col-6 text-right">
                        <span>Total Picking Count :  0{harvestDetailStage?.length}</span>
                    </div>
                    <div className="col-12">
                        <div className="harvest-details-table-scroll mb-5">
                            <table className="table attendedby-table harvest-details-table mb-0">
                                <thead>
                                    <tr>
                                        <th>Harvesting Date</th>
                                        <th>Check Hybrid (tons/ac) </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        harvestDetailStage?.length ?
                                            harvestDetailStage?.map((item, i) => (
                                                <tr key={i}>
                                                    <td>{Utilities.formatDate(item?.check_variety_harvest_date)}</td>
                                                    <td>{harvest?.check_variety_harvest_yield_kg_plot}</td>
                                                </tr>
                                            )) : null
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="row m-md-0">
                            <hr className="w-100" />
                        </div>
                    </div>

                    {/* Remarks Info */}
                    <div className="col-12">
                        <div className="row">
                            <div className="col-md-6 col-12">
                                <span className="d-flex w-100 align-items-center mt-2 mt-md-3">
                                    {SAMPLE_TO_SALE_SCREEN.REMARKS}
                                </span>
                                <span className="d-flex font-weight-medium mb-2">{harvestDetailStage[0].remark}</span>

                                <div className="row m-md-0 d-md-none">
                                    <hr className="w-100" />
                                </div>
                            </div>

                            {/* Images Info */}
                            <div className="col-md-6 col-12">
                                <span className="font-weight-medium d-flex w-100 align-items-center mt-2 mt-md-3 mb-2">{SAMPLE_TO_SALE_SCREEN.IMAGES}</span>
                                <div className="row row7-5 mb-3">
                                    {
                                        this.getImages()?.length ?
                                            this.getImages()?.map((image, i) => (
                                                <ViewImage key={i} image={image.image_url} />
                                            )) : null
                                    }
                                </div>

                                <div className="row m-md-0 d-md-none">
                                    <hr className="w-100" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(HarvestVegView);